import { render, staticRenderFns } from "./comment-button.vue?vue&type=template&id=2e236869&lang=pug&"
import script from "./comment-button.vue?vue&type=script&lang=js&"
export * from "./comment-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports